import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class StripeService {

  stripe: any;
  elements: any;
  stripeInitError = false;
  billingTimezone: string | undefined = environment.STRIPE.DEFAULT_REGION;

  defaultStyles = {
    base: {
      color: 'black',
      fontFamily: '"TT Commons", sans-serif',
      fontSmoothing: 'antialiased',
      fontSize: '14px',
      '::placeholder': {
        fontFamily: '"TT Commons", sans-serif',
        color: 'var(--mid-grey, #BFBFBF)'
      },
      ':hover': {
        backgroundColor: 'var(--input-grey, #F6F6F6)'
      },
      ':focus': {
        border: '1px var(--Greens-Forest, #32735F) solid',
        outline: 'none'
      }
    },
    invalid: {
      color: '#a94442',
      iconColor: '#a94442'
    }
  };

  constructor() {}

  updateBillingTimezone(billingTimezone: string | undefined): void {
    this.billingTimezone = billingTimezone;
  }

  initStripeKey(apiKey) {
    this.stripe = window['Stripe'](apiKey, {locale: 'en'});
  }

  initStripeElements() {
    this.elements = this.stripe.elements();
  }

  mountElement(type: string, selector: string, style = this.defaultStyles) {
    if (!this.elements) {
      console.error('Elements not available, cannot mount element');
      throw new Error('Stripe elements not initialized. Make sure to set billing timezone first.');
    }

    try {
      let el;
      if (type === 'cardCvc') {
        el = this.elements.create(type, {style: style, placeholder: "CVV"});
      } else {
        el = this.elements.create(type, {style: style});
      }
      const mountTarget = document.querySelector(selector);

      if (!mountTarget) {
        console.error(`Mount target ${selector} not found in DOM`);
        return null;
      }

      el.mount(selector);
      return el;
    } catch (error) {
      console.error('Error mounting Stripe element:', error);
      throw error;
    }
  }

  createPaymentMethod(element: any, data = {}): Promise<any> {
    return this.stripe.createPaymentMethod({
      type: 'card',
      card: element,
      // @ts-ignore
      billing_details: data.billing_details
    });
  }

  confirmCardSetup(clientSecret: string, data: any): Promise<any> {
    return this.stripe.confirmCardSetup(clientSecret, {
      payment_method: data.payment_method
    });
  }
}
